var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTemperatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9662_221957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 17.788V5C21 3.67392 20.4732 2.40215 19.5355 1.46447C18.5978 0.526784 17.3261 0 16 0C14.6739 0 13.4021 0.526784 12.4644 1.46447C11.5268 2.40215 11 3.67392 11 5V17.809C10.0742 18.5557 9.32512 19.4981 8.80645 20.5684C8.28778 21.6388 8.01238 22.8107 7.99997 24C7.98859 25.0537 8.18775 26.0991 8.58576 27.0749C8.98377 28.0506 9.57261 28.9371 10.3178 29.6822C11.0629 30.4274 11.9494 31.0162 12.9251 31.4142C13.9008 31.8122 14.9462 32.0114 16 32C17.0537 32.0114 18.0991 31.8122 19.0749 31.4142C20.0506 31.0162 20.937 30.4274 21.6822 29.6822C22.4273 28.9371 23.0162 28.0506 23.4142 27.0749C23.8122 26.0991 24.0114 25.0537 24 24C24.0074 22.8042 23.7409 21.6227 23.2209 20.5459C22.7008 19.4691 21.9411 18.5257 21 17.788ZM16 28C15.0277 28.0012 14.0883 27.6475 13.3583 27.0053C12.6282 26.3631 12.1577 25.4765 12.0349 24.512C11.9122 23.5474 12.1457 22.5712 12.6916 21.7666C13.2375 20.962 14.0583 20.3844 15 20.142V11H17V20.142C17.9416 20.3844 18.7624 20.962 19.3083 21.7666C19.8543 22.5712 20.0878 23.5474 19.965 24.512C19.8423 25.4765 19.3717 26.3631 18.6417 27.0053C17.9116 27.6475 16.9723 28.0012 16 28Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9662_221957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureIcon);
export default __webpack_public_path__ + "static/media/temperatureIcon.85e4fd4cbb30d8b420c6d593e5655240.svg";
export { ForwardRef as ReactComponent };